module.exports = __webpack_public_path__ + "static/media/280737.f229a2ff.png";